import React, { useEffect, useState } from 'react';
import { useCookiesConsent } from '@sbi-international/boutik.package.cookie.consent';
import { useLocalStorage } from '@sbi-international/boutik.gatsby.plugin.services';
import { IInteractionContext, InteractionContext } from './interactionContext';

interface InteractionProviderProps {
    children: React.ReactNode;
}

const isBrowser = typeof window !== 'undefined';

export const InteractionProvider: React.FC<InteractionProviderProps> = ({ children }) => {
    let isAuthCookies = false;
    if (isBrowser) {
        const cookieConsent = useCookiesConsent();
        isAuthCookies = cookieConsent.cookieConsentPreferences.functionality;
    }

    const [isgProEnabled, setProEnabled] = useState<boolean>(true);
    const [isStringProEnabled, setStringProEnabled] = isAuthCookies
        ? useLocalStorage<string>('mfp-pro-enable', 'false')
        : [false, () => {}];
    
    const [isQuickCartVisible, setQuickCartVisible] = useState<boolean>(false);

    const changeIsProEnabled = (value: boolean) => {
        isAuthCookies ? setStringProEnabled(value ? 'true' : 'false') : setProEnabled(value);
    };

    const contextValue: IInteractionContext = {
        isProEnabled: isAuthCookies ? isStringProEnabled === 'true' : isgProEnabled,
        setProEnable: changeIsProEnabled,
        isQuickCartVisible: isQuickCartVisible as boolean,
        setQuickCartVisible: setQuickCartVisible as React.Dispatch<React.SetStateAction<boolean>>,
    };

    return <InteractionContext.Provider value={contextValue}>{children}</InteractionContext.Provider>;
};
